import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import './style.scss';
import ChatFeedback from './ChatFeedback';
import { getChatState, getChatActiveState, getChatItems, getChatEmojis } from 'selectors';
import * as actions from 'actions';
import ChatTextInput from './ChatTextInput';
import ChatItems from './ChatItems';
import ChatWritingIndicator from './ChatWritingIndicator';

export class ChatWindow extends Component {

  constructor() {
    super();

    this.handleMinimize = this.handleMinimize.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMinimized !== this.props.isMinimized) {
      // better scrolling for mobile chat
      const addOrRemove = this.props.isMinimized ? 'remove' : 'add';
      document.documentElement.classList[addOrRemove]('chat-visible');
    }
  }

  handleMinimize() {
    this.props.onMinimize();
  }

  render() {
    const className = classnames(
      'ChatWindow',
      {
        'is-minimised': this.props.isMinimized,
        'has-emoji-visible': this.props.showsEmojis
      });

    const counsellorName = this.props.counsellor && this.props.counsellor.userName;

    return (
      <div className={className}>
        <div className="chatHeader">
          <span className="icon-minus" onClick={this.handleMinimize}></span>
          {(() => {
            if(this.props.isLoading) {
              return <h5>{__('members.chat.loading')}</h5>;
            }

            return <h5>{`Chat with ${counsellorName}`}</h5>;
          })()}
        </div>

        <ChatItems counsellorAvatarImageURL={this.props.counsellor ? this.props.counsellor.avatar.url : null}  />
        <ChatTextInput isDisabled={this.props.isLoading} />
        <ChatWritingIndicator />

        {(() => {
          if(this.props.isWaitingForFeedback) {
            return <ChatFeedback />;
          }
        })()}
      </div>
    );
  }
}

ChatWindow.propTypes = {
  isMinimized: PropTypes.bool,
  onMinimize: PropTypes.func,
  counsellor: PropTypes.object,
  isLoading: PropTypes.bool,
  isWaitingForFeedback: PropTypes.bool,
  updatedFromNewChatItem: PropTypes.bool,
  showsEmojis: PropTypes.bool
};

const mapStateToProps = (state) => {
  const chatState = getChatState(state);
  const chatItems = getChatItems(state);
  const counsellor = getChatActiveState(state).counsellor;

  return {
    isMinimized: (!chatState.isOpened || !chatState.isActive) && !chatState.isWaitingForFeedback,
    counsellor,
    isLoading: chatItems.length === 0 || !counsellor,
    isWaitingForFeedback: chatState.isWaitingForFeedback,
    showsEmojis: getChatEmojis(state, 'chatMessage').areVisible
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onMinimize: () => {
      dispatch(actions.chatClose());
    },
    onMessageTextChange: (text) => {
      dispatch(actions.chatMessageEditingUpdateText({ text }));
    },
    onAddMessage(text) {
      dispatch(actions.chatMessageAdd(text));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatWindow);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/index.js
 **/